// @mui
import Container from '@mui/material/Container';
// routes
import { paths } from 'src/routes/paths';
// components
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import CreateNewPartnerInfoForm from '../create-new-partner-info-form';
//


// ----------------------------------------------------------------------

export default function CreatePartnerView() {
    const settings = useSettingsContext();

    return (
        <Container maxWidth={settings.themeStretch ? false : 'lg'}>
            <CustomBreadcrumbs
                heading="Create Partner"
                links={[
                    {
                        name: 'Dashboard',
                        href: paths.dashboard.driverReview.root,
                    },
                    {
                        name: 'Partner',
                        href: paths.dashboard.partners.partner,
                    },
                    { name: 'Add Partner' },
                ]}
                sx={{
                    mb: { xs: 3, md: 5 },
                }}
            />
            <CreateNewPartnerInfoForm isCreate />
        </Container>
    );
}

